import { api } from "../ModuloGerenciador/UrlPadrao"

export const cadastraFotoUsuario = async (id, midia, token) => {
    return api.post("Midia/editar/fotoUsuario/" + id,
        midia
        , {
            headers: {
                'Authorization': token
            }
        })
}

export const getMidiaIdUsuario = async ({id, token}) => {
    return api.get("Midia/buscarPorIdUsuario/" + id,
        {
            headers: {
                'Authorization': token
            }
        })
}

export const deleteFotoUser = async (id, token) => {
    return api.delete("Midia/" + id,
        {
            headers: {
                'Authorization': token
            }
        })
}

export const getArquivoPorUrlBlob = (url, token) => {
  return api.get(`Midia/buscarPorUrl/` + url, {
    responseType: "blob",
    headers: { Authorization: token },
  });
};